<template>
  <vs-tabs position="left" class="tabs-shadow-none">
    <vs-tab icon-pack="feather" icon="icon-code" label="Guest profiles">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <guest-profiles />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-tag" label="Label setup">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <label-setup />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-shopping-cart" label="Interests setup">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <interest-setup />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-git-pull-request" label="Segmentation tester">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <segmentation-tester />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import GuestProfiles from "./GuestProfiles.vue";
import LabelSetup from "./LabelSetup.vue";
import InterestSetup from "./InterestSetup.vue";
import SegmentationTester from "./SegmentationTester.vue";

import { mapGetters } from "vuex";

export default {
  components: {
    LabelSetup,
    InterestSetup,
    GuestProfiles,
    SegmentationTester,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({}),
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>